import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const NavbarWrapper = styled.nav`
  position: sticky;
  top: 0;
  background: #000000;
  color: #828282;
  padding: 2rem 3rem;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 400px) {
    padding: 0.5rem 1rem;
  }
`;

const Hamburger = styled.div`
  display: none;
  cursor: pointer;
  font-size: 1.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-left: auto;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    background: #000000;
    position: absolute;
    top: 70px;
    left: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    transition: left 0.3s ease-in-out;
    padding: 1rem;
    height: calc(100vh - 70px);
    overflow-y: auto;
  }

  @media (max-width: 400px) {
    gap: 1rem;
    top: 60px;
  }
`;

const NavLink = styled.a`
  color: #828282;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  font-size: 1rem;

  &:hover {
    color: #aaa;
  }

  &:after {
    content: '';
    position: absolute;
    width: 0%;
    height: 2px;
    display: block;
    background: #f5c32c;
    transition: width 0.3s;
    bottom: -4px;
    left: 0;
  }

  &:hover:after {
    width: 100%;
  }
`;

const ResumeButton = styled.a`
  background-color: #828282;
  color: #000000;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-top: -0.5rem;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s, color 0.3s;
  cursor: pointer;

  &:hover {
    background-color: #f5c32c;
    color: #000;
  }

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Navbar = ({ sections }) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (id) => {
    setIsOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(`${id}-section`);
        el?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const el = document.getElementById(`${id}-section`);
      el?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <NavbarWrapper>
      <Hamburger onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </Hamburger>
      <NavLinks isOpen={isOpen}>
        {sections.map((section) => (
          <NavLink
            key={section.id}
            onClick={() => handleClick(section.id)}
          >
            {section.name}
          </NavLink>
        ))}
        <ResumeButton
          href="/resume.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          RESUME
        </ResumeButton>
      </NavLinks>
    </NavbarWrapper>
  );
};

export default Navbar;